export enum CustomerCodeType {
  ABB = "ABB",
  NonABB = "NON-ABB"
}
